// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { SMSThread } from '@/legacy/types/communications/texting'

export const useSmsThreadsApi = apiStore<SMSThread>(
  'smsThreadsApi',
  '/api/communications/sms'
)
